import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  APILoadingStatus,
  APIProvider,
  useApiLoadingStatus
} from '@vis.gl/react-google-maps';
import { getGoogleApiKey } from '../../../utils/helpers/common';
import { getLangDefinition } from '../../../utils/helpers';

interface GoogleMapsLoaderProps {
  children: ReactNode;
  fallback?: ReactNode;
}

const LoadedMapsContent = ({
  children,
  fallback = null
}: GoogleMapsLoaderProps) => {
  const status = useApiLoadingStatus();

  if (status !== APILoadingStatus.LOADED) return <>{fallback}</>;

  return <>{children}</>;
};

export const GoogleMapsLoader = ({
  children,
  fallback
}: GoogleMapsLoaderProps) => {
  const { i18n } = useTranslation();

  return (
    <APIProvider
      apiKey={getGoogleApiKey()}
      language={getLangDefinition(i18n.language)}
      region="AZ"
    >
      <LoadedMapsContent fallback={fallback}>{children}</LoadedMapsContent>
    </APIProvider>
  );
};
